// Storage Cleanup Utility
// Xử lý clear storage khi có version update

const STORAGE_VERSION_KEY = 'app_storage_version';
const CURRENT_VERSION = '1.0.90';

// Function to clear all storage
export function clearAllStorage(): void {
  try {
    console.log('🧹 Clearing all storage...');
    
    // Clear localStorage
    localStorage.clear();
    console.log('✅ localStorage cleared');
    
    // Clear sessionStorage
    sessionStorage.clear();
    console.log('✅ sessionStorage cleared');
    
    // Clear IndexedDB
    if ('indexedDB' in window) {
      indexedDB.databases().then(databases => {
        databases.forEach(db => {
          indexedDB.deleteDatabase(db.name);
        });
      });
      console.log('✅ IndexedDB cleared');
    }
    
    // Clear cookies
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname;
    });
    console.log('✅ Cookies cleared');
    
    // Set new storage version
    localStorage.setItem(STORAGE_VERSION_KEY, CURRENT_VERSION);
    console.log('✅ Storage version updated to:', CURRENT_VERSION);
    
    // Reload page to apply changes
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    
  } catch (error) {
    console.error('❌ Error clearing storage:', error);
  }
}

// Check if storage needs to be cleared
export function checkStorageVersion(): void {
  const storedVersion = localStorage.getItem(STORAGE_VERSION_KEY);
  
  if (!storedVersion || storedVersion !== CURRENT_VERSION) {
    console.log('🔄 Version mismatch detected. Clearing storage...');
    console.log('Stored version:', storedVersion);
    console.log('Current version:', CURRENT_VERSION);
    clearAllStorage();
  }
}

// Initialize storage cleanup
export function initStorageCleanup(): void {
  // Check version on page load
  checkStorageVersion();
  
  // Listen for service worker messages
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'CLEAR_STORAGE') {
        console.log('📨 Received clear storage message from service worker');
        console.log('New version:', event.data.version);
        clearAllStorage();
      }
    });
  }
}
